<template>
    <div class="dialogContainer">
        <div>
            <h2>提示：</h2>
            <p>{{ dialogData.msg }}</p>
            <div>
                <div @click="queren">确认</div>
                <div class="close" v-show="closeBtn" @click="quxiao">取消</div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    data() {
        return {
            closeBtn: false,
        }
    },
    props: ["dialogData"],
    computed: {

    },
    created() {
        
    },
    methods: {
        queren() {
            let that = this;
            if( that.dialogData.type == "logout" ) {
                that.$store.commit("setIsLogout", true);
                that.$emit("dialogClose");
            }else{
                that.$emit("dialogClose");
            }
        },
        quxiao() {
            let that = this;
            that.$emit("dialogClose");
        }
    },
    watch: {
        dialogData(newV) {
            let that = this;
            console.log(newV.type)
            if( newV.type == "logout" ) {
                that.closeBtn = true;
            }
        }
    }
}
</script>
<style lang="scss" scoped>
@function rem($args) {
  $uiWidth: 75px;
  @return $args/$uiWidth * 1rem;
}
.dialogContainer{
    position: absolute;
    left: 0;
    width: 100%;
    bottom: 0;
    top: 0;
    background: rgba($color: #000000, $alpha: .8);
    overflow: hidden;
    z-index: 999999;
    
    >div {
        position: absolute;
        left: 50%;
        top: 50%;
        background: #fff;
        border-radius: rem(10px);
        box-shadow: 0 0 2px #eee;
        transform: translate(-50%, -50%);
        padding: rem(20px) 0;
        width: 70%;
        >h2{
            border-bottom: rem(1px) solid #eee;
            line-height: rem(50px);
            font-size: rem(30px);
            padding: 0 rem(20px);
            margin-bottom: rem(40px);
        }
        >p{
            font-size: rem(24px);
            line-height: rem(40px);
            padding: 0 rem(20px);
            margin-bottom: rem(40px);
            text-align: center;
        }
        >div{
            display: flex;
            justify-content: space-around;
            margin-bottom: rem(20px);
            >div{
                width: rem(100px);
                height: rem(50px);
                line-height: rem(50px);
                font-size: rem(24px);
                text-align: center;
                border-radius: rem(10px);
                background: #349AF6;
                color: #fff;
                &.close{
                    background: #666;
                }
            }
        }
    }
}
</style>
